import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M28.75 33.75a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25ZM28.75 30v-5",
  stroke: "#CB2F4D",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M38.438 34.47a2.958 2.958 0 0 1-2.645 4.28H21.707a2.957 2.957 0 0 1-2.645-4.28l7.043-14.085a2.956 2.956 0 0 1 5.29 0l7.043 14.085Z",
  stroke: "#CB2F4D",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.75 31.25h-10a2.5 2.5 0 0 1-2.5-2.5v-17.5a2.5 2.5 0 0 1 2.5-2.5h25a2.5 2.5 0 0 1 2.5 2.5v2.5",
  stroke: "#6B5997",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "m30.443 9.412-4.701-7.049a2.5 2.5 0 0 0-2.075-1.113H8.833a2.5 2.5 0 0 0-2.08 1.113L2.057 9.412M16.25 1.25v7.5",
  stroke: "#6B5997",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }